import { Routes } from '@angular/router';
import {
  authGuard,
  downsizerDashboardGuard,
  providerAuthGuard,
} from './core/guards/auth.guard.js';

/**
 * Public URL segments: declared before the guarded `path: ''` shell so they always
 * match without running authGuard on a parent.
 */
export const routes: Routes = [
  {
    path: 'shared-property/:uuid',
    loadChildren: () =>
      import('./public-page/public-property.routes').then(
        (m) => m.PUBLIC_PROPERTY_ROUTES
      ),
    canActivate: [],
  },
  {
    path: 'shared-team-member/:token',
    loadChildren: () =>
      import('./public-page/public-team-member.routes').then(
        (m) => m.PUBLIC_TEAM_MEMBER_ROUTES
      ),
    canActivate: [],
  },
  {
    path: '',
    loadChildren: () =>
      import('./downsizer/auth/auth.routes').then((m) => m.AUTH_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./downsizer/onboarding/onboarding.routes').then(
        (m) => m.ONBOARDING_ROUTES
      ),
    canActivate: [authGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./downsizer/dashboard/dashboard.routes').then(
        (m) => m.DASHBOARD_ROUTES
      ),
    canActivate: [authGuard, downsizerDashboardGuard],
  },
  {
    // Legacy path: emails/links sent before the 'agent' route was renamed to 'provider'.
    path: 'agent',
    redirectTo: 'provider',
    pathMatch: 'prefix',
  },
  {
    path: 'provider',
    loadChildren: () =>
      import('./agent/auth/auth.routes').then((m) => m.AGENT_AUTH_ROUTES),
    canActivate: [],
  },
  {
    path: 'provider/dashboard',
    loadChildren: () =>
      import('./agent/dashboard/dashboard-agent.routes').then(
        (m) => m.AGENT_DASHBOARD_ROUTES
      ),
    canActivate: [providerAuthGuard],
  },
  // {
  //   path: 'developer',
  //   loadChildren: () =>
  //     import('./agent/dashboard/dashboard-developer.routes').then(
  //       (m) => m.AGENT_DEVELOPER_DASHBOARD_ROUTES
  //     ),
  //   canActivate: [],
  // },
  // {
  //   path: 'buyers-agent',
  //   loadChildren: () =>
  //     import('./agent/dashboard/dashboard-buyers-agent.routes').then(
  //       (m) => m.BUYERS_AGENT_DASHBOARD_ROUTES
  //     ),
  //   canActivate: [],
  // },
  {
    path: '**',
    loadComponent: () =>
      import('./core/pages/not-found-page/not-found-page.component').then(
        (m) => m.NotFoundPageComponent
      ),
  },
];
